import React from "react";
import PhotoAlbum from "react-photo-album";
import "./ImageCollage.css";

function ImageCollage() {
  // Sample images - using Unsplash for demo purposes
  const photos = [
    {
      src: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1200&q=80",
      width: 1200,
      height: 800,
    },
    {
      src: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=80",
      width: 1200,
      height: 1800,
    },
    {
      src: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1200&q=80",
      width: 1200,
      height: 800,
    },
    {
      src: "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?w=1200&q=80",
      width: 1200,
      height: 900,
    },
    {
      src: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=80",
      width: 1200,
      height: 800,
    },
    {
      src: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1200&q=80",
      width: 1200,
      height: 1600,
    },
    {
      src: "https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=1200&q=80",
      width: 1200,
      height: 800,
    },
    {
      src: "https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=1200&q=80",
      width: 1200,
      height: 900,
    },
    {
      src: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=1200&q=80",
      width: 1200,
      height: 1800,
    },
    {
      src: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&q=80",
      width: 1200,
      height: 800,
    },
    {
      src: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=1200&q=80",
      width: 1200,
      height: 900,
    },
    {
      src: "https://images.unsplash.com/photo-1475924156734-496f6cac6ec1?w=1200&q=80",
      width: 1200,
      height: 800,
    },
    {
      src: "https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?w=1200&q=80",
      width: 1200,
      height: 1600,
    },
    {
      src: "https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?w=1200&q=80",
      width: 1200,
      height: 800,
    },
    {
      src: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=1200&q=80",
      width: 1200,
      height: 900,
    },
  ];

  return (
    <div className="collage-section">
      <div className="collage-container">
        <PhotoAlbum
          layout="rows"
          photos={photos}
          spacing={1}
          columns={(containerWidth) => {
            if (containerWidth < 768) return 1;
            if (containerWidth < 1024) return 2;
            return Math.floor(Math.random() * 2) + 3; // 3 or 4 columns
          }}
        />
      </div>
    </div>
  );
}

export default ImageCollage;
